import { Component, Injector, OnInit } from '@angular/core';
import { CategoryService } from '../../../observations/services/category.service';
import { ActiveModal, ChassisFormHandler } from '@kaiser-software/chassis-core';

@Component({
    selector: 'app-kpi-list-plugin',
    templateUrl: 'select-category.modal.html',
    styleUrls: [ 'select-category.modal.scss' ]
})
export class SelectCategoryModal implements OnInit {

    private title = 'Select category';

    public form: ChassisFormHandler;

    private structure;

    constructor(private injector: Injector, private modal: ActiveModal, private categoryService: CategoryService) {
    }

    ngOnInit() {
        this.modal.set('title', this.title);

        this.setFormStructure();

        this.form = new ChassisFormHandler(this.injector, this.structure, {});

        this.modal.set('form', this.form);

        this.form.processor((data: any, resolve: Function, reject: Function) => {
            resolve(data.category);

            this.modal.close(data.category);
        });
    }

    private setFormStructure() {
        this.structure = {
            groups: [ {
                id: 'group',
                order: 1,
                sections: [ {
                    id: 'section',
                    order: 1,
                    rows: [ {
                        id: 'row',
                        order: 1,
                        elements: [ {
                            id: 'category',
                            type: 'select',
                            name: 'category',
                            label: 'Category',
                            config: {
                                url: this.categoryService.all(true),
                                relation: true,
                                displayColumn: 'code',
                                searchDisplayColumn: 'code',
                                searchQueryColumn: 'code',
                            },
                            validation: {
                                required: true,
                            }
                        } ]
                    } ]
                } ]
            } ]
        };
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/kpis/modals/select-category/select-category.modal.ts